import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const LoginElementFields = {
  group: ELEMENT_GROUPS.AUTH,
  label: 'Login',
  icon: 'KeyIcon',
  description: 'Adds an email and password login element',
  properties: [
    {
      label: 'Post-Login Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description:
        'An action to run when the user has successfully been logged in',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Login Type',
      name: 'loginType',
      editor: 'dropdown',
      default: 'email',
      description: 'The type of button',
      options: [
        {
          label: 'By Email',
          value: 'email'
        },
        {
          label: 'By Phone',
          value: 'phone'
        },
        {
          label: 'Reset Password By Email',
          value: 'reset_email'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Login Role',
      name: 'role',
      editor: 'textbox',
      default: '',
      description: 'A comma separated list of user roles that can login.',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    'alignment',
    'margin',
    'padding',
    {
      label: 'Show Password',
      name: 'showPassword',
      editor: 'boolean',
      description: 'If the password field will not be masked',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Show Button Icon',
      name: 'showButtonIcon',
      editor: 'boolean',
      description: 'If the button should include an icon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Button Icon',
      name: 'buttonIcon',
      editor: 'icon',
      description: 'The button icon',
      displayWhen: [{ field: 'showButtonIcon', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'buttonIconSize',
      label: 'Button Icon Size',
      description: '',
      editor: 'iconsize',
      type: 'number',
      default: 14,
      displayWhen: [{ field: 'showButtonIcon', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonText',
      label: 'Button Text',
      description: '',
      editor: 'textbox',
      type: 'string',
      default: 'Login',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Button Width',
      name: 'buttonWidth',
      editor: 'number',
      description: 'The width of the login button',
      default: 200,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Color',
      name: 'buttonBorderColor',
      editor: 'color',
      description: 'The border color of a list item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Spinner Color',
      name: 'spinnerColor',
      editor: 'color',
      description: 'The spinner color whilst logging in is happening',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Border Radius',
      name: 'buttonBorderRadius',
      editor: 'number',
      description: 'The border radius of the element',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonFont',
      label: 'Button Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 'Login',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'buttonTextAlignment',
      label: 'Button Text Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonPadding',
      label: 'Button Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '10 10 10 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonMargin',
      label: 'Button Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '20 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonColor',
      label: 'Button Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'buttonBackgroundColor',
      label: 'Button Background Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'buttonDisabledColor',
      label: 'Button Disabled Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'buttonDisabledBackgroundColor',
      label: 'Button Disabled Background Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Show Forgot Password Link',
      name: 'showForgotPasswordLink',
      editor: 'boolean',
      default: true,
      description: 'Show the forgot password link',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Forgot Password Screen',
      name: 'forgotPasswordScreen',
      description: 'The destination screen for the forgot password link',
      default: ' ',
      editor: 'dropdown',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [
        { field: 'showForgotPasswordLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'forgotPasswordLinkColor',
      label: 'Forgot Password Link Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      displayWhen: [
        { field: 'showForgotPasswordLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'forgotPasswordLinkFont',
      label: 'Forgot Password Link Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 'Login',
      displayWhen: [
        { field: 'showForgotPasswordLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'forgotPasswordLinkAlignment',
      label: 'Forgot Password Link Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      displayWhen: [
        { field: 'showForgotPasswordLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'forgotPasswordLinkMargin',
      label: 'Forgot Password Link Margin',
      description: '',

      editor: 'boundary',
      type: 'string',
      default: '20 0 0 0',
      displayWhen: [
        { field: 'showForgotPasswordLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Show Signup Link',
      name: 'showSignupLink',
      editor: 'boolean',
      default: true,
      description: 'Show the signup link',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Signup Link Text',
      name: 'signupLinkText',
      editor: 'textbox',
      default: 'Not Registered?',
      description: 'The text to display on the Signup link',
      displayWhen: [{ field: 'showSignupLink', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Signup Screen',
      name: 'signupScreen',
      description: 'The destination screen for the signup link',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'showSignupLink', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Show Try a Different Method Link',
      name: 'showOtherMethodLink',
      editor: 'boolean',
      default: true,
      description: 'Enables a link for them to try a different login method',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Try a Different Method Link Text',
      name: 'otherMethodLinkText',
      editor: 'textbox',
      default: 'Not Registered?',
      description:
        'The text to display on the try a different method login link',
      displayWhen: [
        { field: 'showOtherMethodLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Try a Different Link Screen',
      name: 'otherMethodScreen',
      description: 'The destination screen for the try a different method link',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [
        { field: 'showOtherMethodLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'signupLinkColor',
      label: 'Signup Link Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      displayWhen: [{ field: 'showSignupLink', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'signupLinkFont',
      label: 'Signup Link Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 'Login',
      displayWhen: [{ field: 'showSignupLink', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'signupLinkAlignment',
      label: 'Signup Link Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      displayWhen: [{ field: 'showSignupLink', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'signupLinkMargin',
      label: 'Signup Link Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '20 0 0 0',
      displayWhen: [{ field: 'showSignupLink', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Spinner Color',
      name: 'spinnerColor',
      editor: 'color',
      description:
        'The color of the activity indicator during scan processing.',
      default: '#182fa4',
      displayWhen: [
        {
          field: 'mode',
          operator: '=',
          value: 'scanner'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Spinner Size',
      name: 'spinnerSize',
      editor: 'dropdown',
      description: 'The size of the scanning spinner.',
      default: 'small',
      options: [
        { label: 'Small', value: 'small' },
        { label: 'Large', value: 'large' }
      ],
      displayWhen: [
        {
          field: 'mode',
          operator: '=',
          value: 'scanner'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default LoginElementFields;
